import ProductCreateContainer from "./ProductCreateContainer";

export default ProductCreateContainer;
